import React from 'react';
import { element } from '../../models/element';
import AllergensList from './AllergensList';

export interface LaCarteMenuElementProps {
    element: element
    onAllegensListClick: any;
}
function LaCarteMenuElement(props: LaCarteMenuElementProps) {
    return (
        <div className='mt-2'>

            <div className='flex-between-center '>

                <div className='dish-title '>
                    {props.element.prodotto}
                    {/* {props.element.allergeni.length > 0 ? <>{props.element.allergeni.map(_ => _)}</> : <></>} */}
                </div>
                <div className='dish-price'>
                    {props.element.price}€
                </div>
            </div>
            <div className='flex-start-center'>
                <AllergensList onClick={props.onAllegensListClick} allergens={props.element.allergeni} />
            </div>
            <div className='flex-start-center'>

                <div className='dish-description'>
                    {props.element.descrizione}
                </div>
            </div>
        </div>
    );
}

export default LaCarteMenuElement;